export default __webpack_public_path__ + "static/media/img-0092-china-full-face.ce073ef2.png";